<template>
  <div class="container">
    <div class="g-container">
      <div class="g-group" :style="groupStyle(0)">
        <div class="item-right"></div>
        <div class="item-left"></div>
        <div class="item-top"></div>
        <div class="item-bottom"></div>
        <div class="item-middle"></div>
      </div>
      <div class="g-group" :style="groupStyle(-6)">
        <div class="item-right" :style="itemStyle(-6)"></div>
        <div class="item-left" :style="itemStyle(-6)"></div>
        <div class="item-top" :style="itemStyle(-6)"></div>
        <div class="item-bottom" :style="itemStyle(-6)"></div>
        <div class="item-middle" :style="itemStyle(-6)"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const moveAnimationDuration = ref("12s");
const fadeAnimationDuration = ref("12s");

const groupStyle = (delay: number) => {
  return {
    animationDelay: `${delay}s`,
  };
};

const itemStyle = (delay: number) => {
  return {
    animationDelay: `${delay}s`,
  };
};
</script>

<style scoped lang="scss">
@keyframes move {
  0% {
    transform: translateZ(-500px) rotate(0deg);
  }
  100% {
    transform: translateZ(500px) rotate(0deg);
  }
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  25%,
  60% {
    opacity: 1;
  }
  80% {
    opacity: 0.5;
  }
  90% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
  }
}

.container {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 2000;
  position: fixed;
  top: 0;
  left: 0;
}

.g-container {
  display: inline-block;
  perspective: 4px;
  perspective-origin: 50% 50%;
  position: relative;

  .g-group {
    position: absolute;
    width: 1000px;
    height: 1000px;
    left: -500px;
    top: -500px;
    transform-style: preserve-3d;
    animation: move 12s infinite linear;

    .item-right,
    .item-left,
    .item-top,
    .item-bottom,
    .item-middle {
      position: absolute;
      width: 100%;
      height: 100%;
      background: url("@/assets/white.png");
      background-size: cover;
      opacity: 1;
      animation: fade 12s infinite linear;
    }

    .item-right {
      transform: rotateY(90deg) translateZ(500px);
    }

    .item-left {
      transform: rotateY(-90deg) translateZ(500px);
    }

    .item-top {
      transform: rotateX(90deg) translateZ(500px);
    }

    .item-bottom {
      transform: rotateX(-90deg) translateZ(500px);
    }

    .item-middle {
      transform: rotateX(180deg) translateZ(1000px);
    }
  }
}
</style>
